/* scroll transition plugin for bespoke */
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'


function wheel(options={}) {
    return deck => {
        const { axis='vertical', threshold=5, delay=350 } = options;
        const next = debounce(deck.next, delay, {leading: true, trailing: false});
        const prev = debounce(deck.prev, delay, {leading: true, trailing: false});

        // for debugging
        /*
        deck.on('activate', e => {
            if (e.delta) {
                console.log(e);
            }
        });
        */

        deck.parent.addEventListener('wheel', e => {

            // advance if threshold reached
            const delta = axis === 'vertical' ? e.deltaY : e.deltaX;

            if (delta > threshold) {
                next({ delta });
            }

            if (delta < -threshold) {
                prev({ delta });
            }

        });
    }
}

export default wheel;